import { CloseFill18Icon } from "@vygruppen/spor-icon-react";
import { AffectedTrain } from "features/CenterContent/RoleContent/Vaktleder/types";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ScrollableDialogBody } from "shared/components/ScrollableBody";
import {
  ButtonGroup,
  Button,
  InputChip,
  DialogFooter,
  DialogRoot,
  DropsDialogContent,
  DropsDialogHeader,
  Flex,
  VStack,
} from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";

type CloseTrainsModalProps = {
  closeTrains: () => void;
  selectedTrainIds: AffectedTrain[];
  setSelectedTrainIds: (affectedTrain: AffectedTrain[]) => void;
  closeModal: () => void;
};

export const CloseTrainsModal: FC<CloseTrainsModalProps> = ({
  closeTrains,
  selectedTrainIds,
  setSelectedTrainIds,
  closeModal,
}) => {
  const { t } = useTranslation();
  return (
    <DialogRoot open onOpenChange={closeModal} size="lg" placement="center">
      <DropsDialogContent>
        <DropsDialogHeader>{t("Friskmeld tog")}</DropsDialogHeader>
        <ScrollableDialogBody>
          <VStack alignItems="start" gap="18px">
            <Text>
              {t("Er du sikker på at du vil friskmelde følgende tog?")}
            </Text>
            <Flex alignItems="start" flexWrap="wrap" gap="6px">
              {selectedTrainIds.map((trainId) => {
                const isLast = selectedTrainIds.length === 1;
                return (
                  <InputChip
                    key={`${trainId.trainId.identifier}_${trainId.trainId.nominalDate}`}
                    // @ts-expect-error
                    disabled={isLast}
                    size="sm"
                    pe={isLast ? undefined : "1"}
                    endIcon={isLast ? undefined : CloseFill18Icon}
                    onClick={
                      isLast
                        ? undefined
                        : () => {
                            const newSelectedTrainIds = selectedTrainIds.filter(
                              (it) => it !== trainId,
                            );
                            setSelectedTrainIds(newSelectedTrainIds);
                            if (newSelectedTrainIds.length === 0) closeModal();
                          }
                    }
                    style={{
                      pointerEvents: "auto",
                    }}
                  >
                    {trainId.trainId.identifier}
                  </InputChip>
                );
              })}
            </Flex>
          </VStack>
        </ScrollableDialogBody>
        <DialogFooter flexDir="column">
          <ButtonGroup mt="12px" w="full" justifyContent="space-between">
            <Button type="button" variant="tertiary" onClick={closeModal}>
              {t("Avbryt")}
            </Button>
            <Button
              onClick={() => {
                closeTrains();
                closeModal();
              }}
              variant="primary"
            >
              {t("Friskmeld tog")}
            </Button>
          </ButtonGroup>
        </DialogFooter>
      </DropsDialogContent>
    </DialogRoot>
  );
};
